import { Button } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const ModalBody = styled.div`
  background-color: var(--color-gray-25);
  border-radius: var(--size-border-radius-md);
  display: flex;
  padding: 27px 24px;
`;

const Content = styled.div``;

const ContentTitle = styled.div`
  color: var(--color-neutral-800);
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  margin-bottom: 3.2rem;
`;

const ContentDescription = styled.div`
  color: var(--color-accent-secondary-default);
  font-size: 16px;
  line-height: 150%;
`;

const ContentButton = styled(Button)`
  font-size: 12px;
  font-weight: 700;
`;

export { Content, ContentButton, ContentDescription, ContentTitle, ModalBody };
